export default __webpack_public_path__ + "static/media/PT.80072ed0.ico";